//node_modules
import React, { FunctionComponent } from "react";
import { NextSeo } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

const title = "Meet the Gray's - Adjust to the Good Life Travel";
const description = "We are a Raleigh, North Carolina based travel agency specializing in helping families and couples find and experience the most amazing dream vacations.";

const MetaComponent: FunctionComponent = () => {
  const canonical = useCanonical();
  const src = getImageLoaderAbsoluteSrc("/images/d40aaf23ea6975f9fd137914e53aeaef.png", 1200);

  return (
    <NextSeo
      title={title}
      description={description}
      canonical={canonical}
      noindex={false}
      nofollow={false}
      openGraph={{
        type: "website",
        siteName: "Adjust to the Good Life Travel",
        url: canonical,
        title: title,
        description: description,
        images: [
          {
            url: src,
          },
        ],
      }}
      twitter={{
        cardType: "summary_large_image",
      }}
    />
  );
};

export default React.memo(MetaComponent);
